import _ from 'lodash';
/* eslint-disable no-useless-escape */
export const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;
export const MINIMUM_PASSWORD_LENGTH = _.get(window, 'Livewire.minPasswordLength', 8);
export const URL_REGEX = /^(http|https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
/* eslint-enable no-useless-escape */
export const TZ = 'Australia/Sydney';
